import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { CloseIcon } from '@/components/common/close-icon';
import { SearchIcon } from '@/components/common/search-icon';
import { SpinningIcon } from '@/components/common/spinning-icon';
import { Button, ButtonVariant } from '@/components/form/button';
import { Input } from '@/components/form/input';

interface IProps {
  onChange?: (v: string) => void;
  onSearch?: (v: string) => void;
  isLoading?: boolean;
}

export const SearchInput: React.FC<IProps> = ({
  onChange,
  onSearch,
  isLoading = false,
}) => {
  const theme: any = useTheme();
  const { t } = useTranslation();

  const [value, setValue] = useState('');

  // use track to state of the search box, whether it has changed or ...
  const [searchTerm, setSearchTerm] = useState('');

  const onValueChange = (str: string) => {
    setValue(str);
    if (onChange) onChange(str);
  };

  const handleOnSearch = () => {
    if (searchTerm === value) {
      onSearch && onSearch('');
      setValue('');
      setSearchTerm('');
      return;
    }

    if (onSearch) {
      setSearchTerm(value);
      onSearch(value);
    }
  };

  return (
    <div className="relative">
      <Input
        name="search"
        placeholder={`${t('common.search')} ...`}
        className="w-full md:w-full"
        onChange={(e) => onValueChange(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && handleOnSearch()}
        value={value}
      />
      <span className="absolute inset-y-0 flex items-center pl-2 right-3">
        <Button
          variant={ButtonVariant.Link}
          onClick={handleOnSearch}
          disabled={isLoading}
        >
          {isLoading ? (
            <SpinningIcon color={`fill-${theme.current}-primary`} />
          ) : value !== '' && searchTerm === value ? (
            <div className="text-gray-400">
              <CloseIcon />
            </div>
          ) : (
            <div className="text-gray-400">
              <SearchIcon />
            </div>
          )}
        </Button>
      </span>
    </div>
  );
};
